import PropTypes from "prop-types";
import "./EmptyState.scss";

function EmptyState({ title, text, buttonLabel, onAction }) {
  return (
    <div className="empty-state">
      <p className="empty-state-title">{title}</p>
      <p className="empty-state-text">{text}</p>
      {buttonLabel && onAction && (
        <button type="button" className="themeBtn empty-state-button" onClick={onAction}>
          {buttonLabel}
        </button>
      )}
    </div>
  );
}

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  onAction: PropTypes.func,
};

export default EmptyState;
